export const fadeInTime = .11;
export const fadeOutTime = .11;
export const nudgeTime = .11;

export const Holds = [
  {
    type: "short",
    duration: 1
  },
  {
    type: "medium",
    duration: 1
  },
  {
    type: "long",
    duration: 1
  }
];

export const TextSizes = [
  {
    type: "small",
    className: "text-[48px] md:text-[80px] leading-[52px] md:leading-[85px]"
  },
  {
    type: "half",
    className: "text-[25px] md:text-[45px] leading-[27.5px] md:leading-[52.5px]"
  },
  {
    type: "large",
    className: "text-[50px] md:text-[90px] leading-[55px] md:leading-[105px]"
  },
  {
    type: "medium",
    className: "text-[50px] md:text-[90px] leading-[55px] md:leading-[105px]"
  }
];

export const Sizes = [
  {
    type: "small",
    className: "lg:w-[510px]"
  },
  {
    type: "medium",
    className: "lg:w-[600px]"
  },
  {
    type: "large",
    className: "lg:w-[1000px]"
  },
  {
    type: "interstitial",
    className: "lg:w-min"
  }
];

export const Positions = [
  {
    type: "topLeft",
    className: "lg:items-start lg:justify-start"
  },
  {
    type: "topCenter",
    className: "lg:items-start lg:justify-center"
  },
  {
    type: "topRight",
    className: "lg:items-start lg:justify-end"
  },
  {
    type: "centerLeft",
    className: "lg:items-center lg:justify-start"
  },
  {
    type: "centerCenter",
    className: "lg:items-center md:justify-center"
  },
  {
    type: "centerRight",
    className: "lg:items-center lg:justify-end"
  },
  {
    type: "bottomLeft",
    className: "lg:items-end lg:justify-start"
  },
  {
    type: "bottomCenter",
    className: "lg:items-end lg:justify-center"
  },
  {
    type: "bottomRight",
    className: "lg:items-end lg:justify-end"
  },
];
